import { render, staticRenderFns } from "./OmzR_Result_InvoiceSummary.vue?vue&type=template&id=2e2d19cc"
import script from "./OmzR_Result_InvoiceSummary.vue?vue&type=script&lang=js"
export * from "./OmzR_Result_InvoiceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports